<template>
  <b-row>
    <b-col cols="12">
      <search-view :click-search="getTypologies"/>
    </b-col>

    <b-col cols="12">
      <b-card title="">
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="ml-1 mb-2">
            <b-row>
              <b-col cols="12" md="9"
                     class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-button variant="primary ml-1" @click="goToCreate()">
                  Añadir nuevo tipo de instalación
                </b-button>
                <div class="ml-2">
                  <button class="btn btn-outline-success" @click="exportToExcel">Exportar a Excel</button>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="typologies"
              responsive
              striped
              sticky-header
              :fields="columns"
              primary-key="id"
              show-empty
              empty-text="No hay registros"
          >
            <template #cell(actions)="data" class="col-sm-2">
              <router-link :to="{ name: 'auxiliar_installationTypes_edit_gei', params: { id: data.item.id} }">
                <feather-icon
                    :id="`invoice-row-${data.item.id}-send-icon`"
                    icon="EditIcon"
                    class="cursor-pointer"
                    size="16"
                />

              </router-link>

<!--              <feather-icon-->
<!--                  :id="`invoice-row-${data.item.id}-preview-icon`"-->
<!--                  icon="TrashIcon"-->
<!--                  size="16"-->
<!--                  class="cursor-pointer ml-1 text-red"-->
<!--                  @click="deleteTypology(data.item.id)"-->
<!--              />-->
<!--              <b-tooltip-->
<!--                  title="Eliminar Instalación"-->
<!--                  :target="`invoice-row-${data.item.id}-preview-icon`"-->
<!--              />-->
            </template>
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ pageLength }} de {{ totalRecords }} tipos de instalaciones</span>
              </b-col>

              <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                    :value="1"
                    :total-rows="totalRecords"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="changePage"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {BRow, BCol, BTable, BCard, BButton, BOverlay, BPagination} from 'bootstrap-vue'
import {mapState} from "vuex"
import Swal from "sweetalert2"
import {GEI_AUXILIAR_INSTALLATIONTYPES_CREATE} from "@/router/web/constants"
import helpers from "@/resources/helpers/helpers"
import helper from "@/resources/helpers/helpers"
import ExcelJS from "exceljs"
import SearchView from "@/views/gei/auxiliars_installationTypes/list/components/searchView"

export default {
	name: "ListView",
  components: {
    SearchView,
    BRow,
    BCol,
    BTable,
    BCard,
    BButton,
    BOverlay,
    BPagination
  },
	data() {
		return {
      page: 1,
      pageLength: 10,
      totalRecords: 10,
      columns: [
        {key: 'description', label: 'Tipo de Instalación', sortable: false},
        {key: 'name', label: 'Tipología', sortable: false},
        {key: 'actions', label: 'Acciones', sortable: false},
      ],
			showLoading: false,
      helpers
		}
	},
	computed: {
    ...mapState('typologies', ['typologies', 'search']),
	},
	created() {
		this.getTypologies()
	},
	methods: {
		can(permission) {
			return this.$store.getters.can(permission)
		},
    getTypologies() {
			this.showLoading = true

      this.$store.dispatch('typologies/getAllTypologies', {
        per_page: this.pageLength,
        page: this.page,
        filter: this.search,
      })
				.then(response => {

					this.showLoading = false
          this.totalRecords = response.total_records
        })
				.catch(error => {
					this.showLoading = false
					console.log(error)
				})
		},
    async exportToExcel() {
      try {
        this.showLoading = true

        const response = await this.$store.dispatch('typologies/getAllTypologies', {
          per_page: this.totalRecords,
          page: 1,
          filter: this.search
        })

        const allInstallationTypes = response.data

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Tipos de Instalaciones')

        worksheet.columns = [
          { header: 'Tipo de instalación', key: 'description', width: 30 },
          { header: 'Tipología', key: 'name', width: 20 }
        ]

        allInstallationTypes.forEach(installationType => {
          worksheet.addRow({
            description: installationType.description,
            name: installationType.name
          })
        })

        worksheet.columns.forEach(column => {
          column.alignment = { vertical: 'middle', horizontal: 'left' }
        })

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'TiposDeInstalaciones.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)

        this.showLoading = false
      } catch (err) {
        this.showLoading = false
        console.error('Error al exportar a Excel:', err)
      }
    },


    deleteTypology(id) {
			Swal.fire({
        title: "¿Estás seguro que quieres eliminar este tipo de instalación?",
        text: "¡Una vez borrada no se podra recuperar!",
        icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#34c38f",
				cancelButtonColor: "#f46a6a",
				confirmButtonText: "Sí, borrar!",
				cancelButtonText: "Cancelar",
			}).then(result => {
				if (result.value) {
					this.$store.dispatch('typologies/deleteTypology', id)
						.then(response => {
							this.showLoading = false
              helper.showToast('Tipo de instalación eliminado correctamente!', 'CheckIcon', 'success')
							this.getTypologies()
						})
						.catch(error => {
							this.showLoading = false
              helper.showToast('Error al eliminar el tipo de instalación', 'AlertOctagonIcon', 'danger')
              console.log(error)
						})
				}
			})
		},
		goToCreate(){
			this.$router.push(GEI_AUXILIAR_INSTALLATIONTYPES_CREATE)
		},
    changePage(page) {
      this.page = page
      this.getTypologies()
    },
    changeLength(length) {
      this.length = length
      this.getTypologies()
    },
	}
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>